/*
 * @Author: Sam
 * @Date: 2020-10-12 15:23:33
 * @LastEditTime: 2020-10-13 14:50:24
 * @LastEditors: Sam
 * @Description: 
 * @FilePath: \thework\tofba-client\src\settings.js
 * @可以输入预定的版权声明、个性签名、空行等
 */
module.exports = {
  title: '',

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: true,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false
}
